export enum PayrollScaleValueType {
WorkExpirience,
NumberOfChildren,
PayrollCategory,
ManualInput,
}
